module.exports = __webpack_public_path__ + "static/media/programmes-icon.ef2e1f81.svg";